const TRACKING_ENABLED = 'shopify';
const isInventoryProduct = (element) => $(element).data('product') === ProductTypes.PRODUCT;
const isTrackingEnabledForProduct = (element) => $(element).data('inventory-managament') === TRACKING_ENABLED;
async function getAvailableQuantityForBundle(bundleId) {
    let bundleChildVariants = await getBundleChildQuantities(bundleId, 1000);

    return Math.min.apply(null, bundleChildVariants)
}

async function getBundleChildQuantities(bundleId, defaultQuantity = 0){
    // Make a call to the get Child Variants
    let childVariants = await getChildProductVariants(bundleId);

    let bundleChildVariants = []
    for (const childVariant of childVariants) {
        // Get Child Quantity
        let quantity = await getVariantQuantity(childVariant, defaultQuantity);
        bundleChildVariants.push(quantity);
    }

    return bundleChildVariants;
}

async function getVariantQuantity(variantId, defaultQuantity = null) {
    let variant;
    try {
        variant = await getVariantInfo(variantId);
    }
    catch (e) {
        ontech.log.error(e);
    }

    return isTrackingEnabled(variant) ? variant.inventory_quantity : defaultQuantity;
}

async function isOutOfStock(variantId) {
    let quantity;

    const product = await getProductInfoForVariant(variantId);

    if(isCartItemBundle(product)){
        quantity = await getAvailableQuantityForBundle(variantId);
    }
    else {
        quantity = await getVariantQuantity(variantId);
    }

    return Math.min.apply(null, quantity) <= 0;
}

const isTrackingEnabled = variant => {
    if(variant instanceof ShopifyProductVariant){
        return variant.isTrackingEnabled();
    }

    return isTrackingEnabledForVariant.call(variant);
}

/** ToDo: Logic Below may not be needed as Caching is now used for Product and Variant information **/
function addInventoryToStateUsingVariantId(arrayOfVariantId) {
    arrayOfVariantId.forEach(async function (item) {
        let variant = await getVariantInfo(item.id);
        if (isTrackingEnabled(variant)) {
            let inventoryAvailable = stockAvailableInState(variant.sku);
            if (!inventoryAvailable) {
                let product = await getProductInfo(variant.productId);
                if (!isEmpty(product) && isCartItemProduct(product)) {
                    ontech.state.do(State.Actions.PRODUCT_AVAILABILITY_CHECK, { prodSku: variant.sku, qty: variant.inventory_quantity });
                }
            }
        }
    })
}

//Returns stock available in state for the sku passed as param, else returns null
function stockAvailableInState(sku) {
    for (const [key, value] of Object.entries(ontech.state.get(State.PRODUCT_AVAILABILITY))) {
        if (sku === key) {
            return value;
        }
    }
    return null;
}

// async function isProductOutOfStock(variantId = null, variantSku = null) {
//     let sku, variant;
//     if (variantId) {
//         variant = await getVariantInfo(variantId);
//         sku = variant.sku
//     }
//     if (variantSku) sku = variantSku
//     let inventoryAvailable = stockAvailableInState(sku);
//     if (inventoryAvailable && inventoryAvailable > 0) return false
//     else if (inventoryAvailable && inventoryAvailable <= 0) return true
//     else {
//         addInventoryToState([])
//     }
    
// }

// async function isProductOutOfStock(variantId) {
//     let inventoryAvailable = getVariantQuantity(variantId);
//     //addInventoryToStateUsingVariantId([variantId]) //will add inventory to state only if it is not available
//     //let inventoryAvailable = stockAvailableInState(variant.sku);
//     return !isUndefinedOrNull(inventoryAvailable) && inventoryAvailable <= 0;
//     //we will return product is not in stock only if
//     //inventory is set in state and it is less than or equal to zero
//     //for all other cases we return in stock to handle cases for variants which are not products as well
// }

async function productStockQuantity(variantId) {
    let variant = await getVariantInfo(variantId);
    //addInventoryToStateUsingVariantId([variantId]) //will add inventory to state only if it is not available
    //let inventoryAvailable = stockAvailableInState(variant.sku);
    let inventoryAvailable = variant.inventory_quantity;
    return inventoryAvailable < 0 ? 0 : inventoryAvailable;
    //we will return product is not in stock only if
    //inventory is set in state and it is less than or equal to zero
    //for all other cases we return in stock to handle cases for variants which are not products as well
}